






















































































import FormCrearProveedor from './FormCrearProveedor.vue';
import FormEditarProveedor from './FormEditarProveedor.vue';
import ModalVerHistorico from './ModalVerHistorico.vue';

import DatePicker from '@/reusable/Form/DatePicker.vue';

import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '../../components/Confirmation.vue';
import { eventBus, actionsEvent } from '@/setup';
import HandleErrors from '../../config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { utils, writeFileXLSX } from 'xlsx';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchProveedores } from './fetchProveedores';

@Component({
  components: {
    MantenedorGridSinCodigo,
    FormCrearProveedor,
    FormEditarProveedor,
    DatePicker,
    Confirmation,
    ModalVerHistorico,
  },
})
export default class MantenedorProveedores extends ComponenteBase {
  dialogConfirmacionClose: boolean = false;
  filtro: any;
  ordesList: any[] = [];
  consulta: any = {
    orden: '',
    tecnico: '',
    coordinador: '',
    localidad: '',
    courier: '',
    dateStart: moment()
      .subtract(1, 'month')
      .format('YYYY/MM/DD'),
    dateEnd: moment().format('YYYY/MM/DD'),
  };
  funcionalidad: Funcionalidades = Funcionalidades.MantenedorProveedores;

  ruts: any = [];
  dataTotal: any = [];

  exportarExcel() {
    let informacionOrdenada = this.ordesList.map((e: any) => ({
      Tipo: e.tipo,
      'Rut - id': e.proveedorrut,
      'Razón Social': e.proveedorrazon,
      Dirección: e.proveedordireccion,
      País: e.proveedorpais,
      Teléfono: e.proveedortel,
      Contacto: e.proveedorcontacto,
      Email: e.proveedoremail,
      'Producto o Servicio': e.es_producto,
      'Es Contrato': e.es_contrato,
      'Tipo de Producto o Servicio': e.provee_tipo_producto,
      'Estratégico o Común': e.es_estrategico,
      Condición: e.proveedorcondicion,
      Moneda: e.descripcion,
      Estado: e.estado,
    }));
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Proveerdores');
    writeFileXLSX(wb, 'Proveerdores.xlsx');
    this.$snotify.success('Excel Exportado con éxito', 3000);
  }

  async getProveedor() {
    this.ruts = [];
    let self = this;
    this.loadingService.showLoading();
    return fetchProveedores({}, 'conectaMantenedorProveedores/inicio')
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          data.data.data.LISTA.forEach((e: any) => {
            this.ruts.push(e.proveedorrut);
          });
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error Al Cargar Los Proveedores', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  async deleteProveedor(rut: string) {
    let self = this;
    this.loadingService.showLoading();
    return fetchProveedores(
      { proveedorRut: rut },
      'conectaMantenedorProveedores/eliminar'
    )
      .then((data: any) => {
        self.$snotify.success('Proveedor Eliminado Con Éxito', {
          timeout: 3000,
        });
        this.loadingService.hideLoading();
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error Al Eliminar El Proveedor', {
          timeout: 3000,
        });
        this.loadingService.hideLoading();
      });
  }

  async getCompra(rut: string) {
    let self = this;
    this.loadingService.showLoading();
    return fetchProveedores(
      { proveedorRut: rut },
      'conectaMantenedorProveedores/getCompra'
    ).then((data: any) => {
      if (data.data.CODIGO_RESPUESTA == '1') {
        data.data.data.LISTA.forEach((e: any) => {
          this.ruts.push(e.proveedorrut);
        });
        this.loadingService.hideLoading();
        return data.data.data.LISTA;
      } else {
        this.loadingService.hideLoading();
      }
    });
    /* .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      }) */
  }

  compras: any;
  delete: any;

  async comprobarCompras(rut: string) {
    this.compras = await this.getCompra(rut);
    if (this.compras) {
      this.$snotify.error(
        'No Se Puede Eliminar Este Proveedor Ya Que Tiene Compras',
        { timeout: 3000 }
      );
    } else {
      this.delete = await this.deleteProveedor(rut);
      this.ordesList = await this.getProveedor();
      this.gridApi.setRowData(this.ordesList);
    }
  }

  usuarioActivo: any = {};

  async getUsuario() {
    let self = this;
    let user = JSON.parse(localStorage.getItem('user')).id;

    return fetchProveedores(
      { userId: user },
      'conectaMantenedorProveedores/getUsuario'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.usuarioActivo = data.data.data;
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió Un Error Al Obtener El Usuario', {
          timeout: 3000,
        });
      });
  }

  async datoEditado(dato: boolean) {
    if (dato) {
      this.ordesList = await this.getProveedor();
      this.gridApi.setRowData(this.ordesList);
    }
  }

  async datoNuevo(dato: any) {
    if (dato) {
      this.ordesList = await this.getProveedor();
      this.gridApi.setRowData(this.ordesList);
    }
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = await this.getProveedor();
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  showModalNew = false;
  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };

  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: false,
  };

  accionVerHistorico: PermisoAccion = {
    accionCodigo: 112,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionVerHistorico,
  ];

  // Globales
  tabModel: string = 'tab-3';
  dialog: Boolean = false;
  search: string = '';

  gridOptions: GridOptions;

  loadingService = new LoadingService();
  intervalo: any; //Intervalo para el buscador
  chequearPermisosBtnCrear: boolean = true;
  editedIndex: number = -1;

  handleErrors: HandleErrors = new HandleErrors();

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  estadoGrillaVm: EstadoGrillaVm;
  serverSide: any;

  // Interfaces
  editedItem: IFuncionalidad = {};
  funcionalidades: Array<IFuncionalidad> = [];
  data: any = {};

  //vuex
  usuarioId: number = store.state.userId;

  // Componentes
  //showModalNew: boolean = false;
  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;
  uppercaseFormatter(params: any) {
    return params.value.toUpperCase();
  }

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY/MM/DD');
  }

  constructor() {
    super();

    actionsEvent.onEditar(this.handleEdit);
    actionsEvent.onVerHistorico(this.handleViewHistory);

    this.columnDefs = [
      {
        headerName: 'Tipo',
        field: 'tipo',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 120,
        width: 160,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Rut - id',
        field: 'proveedorrut',
        resizable: true,
        sortable: true,
        hide: false,
        minWidth: 100,
        width: 120,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Razón Social',
        field: 'proveedorrazon',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'Dirección',
        field: 'proveedordireccion',
        resizable: true,
        sortable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
      },
      {
        headerName: 'País',
        field: 'proveedorpais',
        sortable: true,
        resizable: true,
        width: 170,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Teléfono',
        field: 'proveedortel',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Contacto',
        field: 'proveedorcontacto',
        sortable: true,
        resizable: true,
        width: 200,
        minWidth: 200,
        lockPinned: true,
        filter: false,
      },
      {
        headerName: 'Email',
        field: 'proveedoremail',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Producto o Servicio',
        field: 'es_producto',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Es Contrato',
        field: 'es_contrato',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Tipo de Producto o Servicio',
        field: 'provee_tipo_producto',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Estratégico o Común',
        field: 'es_estrategico',
        width: 205,
        minWidth: 200,
        lockPinned: true,
        sortable: true,
        resizable: true,
      },
      {
        headerName: 'Condición',
        field: 'proveedorcondicion',
        resizable: true,
        width: 200,
        minWidth: 120,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Moneda',
        field: 'descripcion',
        resizable: true,
        width: 200,
        minWidth: 120,
        lockPinned: true,
        sortable: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        resizable: true,
        sortable: true,
        width: 150,
        minWidth: 150,
        lockPinned: true,
        cellRenderer: params => {
          return `<i class="material-icons" style="width: 15px; height: 15px;margin-top: 7px; border-radius: 50%; background: ${
            params.data.estado == 'INACTIVO' ? 'rgb(255, 58, 58)' : '#26FF26'
          }"></i>
            <a style="color: #4f4f4f; position: absolute; margin-top: 0%; margin-left: 3%">
            ${params.data.estado}
            </a>
            `;
        },
      },
    ];

    this.gridOptions = {
      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50, //Solución Paginación
      cacheBlockSize: 10000, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          //cellRenderer: this.fechaFilter,
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,

      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  handleEdit(params: any) {
    this.data = params.data;
  }

  handleViewHistory(params: any) {
    this.data = params.data;
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  mounted() {
    eventBus.changeTitlePage('Módulos');
    this.getUsuario();
  }

  created() {
    this.initialize();
  }

  onFilterTextBoxChanged() {
    clearInterval(this.intervalo);
    const self = this;
    this.intervalo = setInterval(function() {
      if (self.search.length >= 2) {
        self.gridApi.onFilterChanged();
      } else if (self.search.length === 0) {
        self.gridApi.setServerSideDatasource(self.serverSide);
      }
      clearInterval(self.intervalo);
    }, 500);
  }
  rutSelected: string = '';
  razonSelected: string = '';
  showModalHistorico: boolean = false;
  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (this.funcionalidad === Funcionalidades.MantenedorProveedores) {
        if (data.action === Accion.Eliminar) {
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.rutSelected = data.cellRendererParams.data.proveedorrut;
            this.dialogConfirmacionClose = true;
          }
        } else if (
          data.action === Accion.Editar ||
          data.action === Accion.VerHistorico
        ) {
          this.editedItem = null;
          // Editar - Ver Detalle
          this.modalEsEdicion = data.action == Accion.Editar;
          this.editedIndex = data.id;

          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            this.showModalEdit = data.action === Accion.Editar;
            this.showModalHistorico = data.action === Accion.VerHistorico;
            this.razonSelected = data.cellRendererParams.data.proveedorrazon;
          }
        }
      }
    });
  }

  beforeDestroy() {}

  moduloModalCallback(val: boolean) {
    this.showModalNew = val;
    this.showModalEdit = val;
    this.showModalHistorico = val;
    this.data = {};
    //this.obtenerMayor()+1;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.comprobarCompras(this.rutSelected);
    }
  }
}
